import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Locations from "@/pages/Locations";
import Equipment from "@/pages/Equipment";
import PMChecklist from "@/pages/PMChecklist";
import Faults from "@/pages/Faults";
import Parts from "@/pages/Parts";
import Reports from "@/pages/Reports";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/equipment" element={<Equipment />} />
              <Route path="/pm" element={<PMChecklist />} />
              <Route path="/faults" element={<Faults />} />
              <Route path="/parts" element={<Parts />} />
              <Route path="/reports" element={<Reports />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" />
    </div>
  );
}

export default App;
